import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Timeline, Button } from 'antd';
import { Link } from 'react-router-dom';
import { IMG_DEFAULT } from '../../common/baseConfig';
import NoneData from '../common/NoneData';
import Tabs from './Tabs';
export class ClassRecord extends Component {
  state = {
    defaultActiveKey: 0,
    showAllrecord: false,
  };
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchGetLookInfo();
  }
  renderItem(item, index) {
    const format = (str, type) => {
      let strArr = str.split('-');
      if (type === 'year') {
        return strArr[0];
      } else {
        return `${strArr[1]}月${strArr[2]}日`;
      }
    };
    return (
      <Timeline.Item
        key={index}
        dot={<img src={require('../../images/circle.png')} alt="" />}
        data-year={format(item[0].LookDate, 'year')}
        data-date={format(item[0].LookDate, 'date')}
      >
        <div className="contentItem">
          {item.map(it => {
            return (
              <div key={it.ID} className="item">
                <div className="content">
                  <Link to={'/course/detail/' + it.ID}>
                    <img
                      src={
                        it.CoverPath
                          ? it.CoverPath + '?x-oss-process=image/resize,m_fixed,h_90,w_160'
                          : IMG_DEFAULT
                      }
                      alt=""
                    />
                  </Link>
                  <h2>
                    <p>{it.Name}</p>
                    <p>
                      已学至 <span>{it.ChapterName}</span>
                    </p>
                    <p>
                      已学{' '}
                      {it.LookHours >= it.SumHours
                        ? '100'
                        : ((it.LookHours / it.SumHours) * 100).toFixed(2)}
                      %
                    </p>
                  </h2>
                </div>
                <div className="btns">
                  <Button
                    type="theme"
                    className="goStudy"
                    onClick={() => {
                      this.props.history.push(
                        `/course/video/${it.ID}-${it.CourseChapters_ID}-${it.WareId}`,
                      );
                    }}
                  >
                    继续学习
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </Timeline.Item>
    );
  }
  render() {
    const { defaultActiveKey, showAllrecord } = this.state;
    let { fetchGetLookInfoPending, fetchGetLookInfoSuccess } = this.props.center;
    let Data = [];
    if (showAllrecord && fetchGetLookInfoSuccess) {
      Data = fetchGetLookInfoSuccess;
    } else {
      Data = fetchGetLookInfoSuccess.slice(0, 4);
    }
    return (
      <div className="center-class-record">
        <div className="tabs">
          <Tabs {...this.props} defaultActiveKey={defaultActiveKey} tabs={[{ Name: '听课记录' }]} />
        </div>
        <div className="class-record-time-line">
          {Data.length === 0 && (
            <div className="noneData">
              <NoneData type={2} />
            </div>
          )}
          <Timeline pending={fetchGetLookInfoPending}>
            {Data.length > 0 && Data.map((item, index) => this.renderItem(item, index))}
          </Timeline>
          {!showAllrecord && (
            <div
              className="showAll"
              onClick={() => {
                this.setState({
                  showAllrecord: true,
                });
              }}
            >
              <p>显示全部听课记录</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassRecord);



// WEBPACK FOOTER //
// ./src/features/center/ClassRecord.js